import { render, staticRenderFns } from "./TeachingAssignment.vue?vue&type=template&id=2cde03a4&"
import script from "./TeachingAssignment.vue?vue&type=script&lang=js&"
export * from "./TeachingAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports